module.exports = __webpack_public_path__ + "media/Barber_shop.3362f7e4.mp3";